var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8399,16.1931 C15.8399,19.4891 11.3199,19.8701 7.9209,19.8701 L7.67766371,19.8698897 C5.51210414,19.8646311 -0.0001,19.7279077 -0.0001,16.1731 C-0.0001,12.9443653 4.33825235,12.5128651 7.71138402,12.4965976 L8.16412764,12.4963103 C10.329545,12.5015689 15.8399,12.6382923 15.8399,16.1931 Z M7.9209,13.9961 C3.6599,13.9961 1.4999,14.7281 1.4999,16.1731 C1.4999,17.6311 3.6599,18.3701 7.9209,18.3701 C12.1809,18.3701 14.3399,17.6381 14.3399,16.1931 C14.3399,14.7351 12.1809,13.9961 7.9209,13.9961 Z M7.9209,-0.0003 C10.8489,-0.0003 13.2299,2.3817 13.2299,5.3097 C13.2299,8.2377 10.8489,10.6187 7.9209,10.6187 L7.8889,10.6187 C4.9669,10.6097 2.5999,8.2267 2.60986843,5.3067 C2.60986843,2.3817 4.9919,-0.0003 7.9209,-0.0003 Z M7.9209,1.4277 C5.7799,1.4277 4.03787882,3.1687 4.03787882,5.3097 C4.0309,7.4437 5.7599,9.1837 7.8919,9.1917 L7.9209,9.9057 L7.9209,9.1917 C10.0609,9.1917 11.8019,7.4497 11.8019,5.3097 C11.8019,3.1687 10.0609,1.4277 7.9209,1.4277 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.edd3d92254ff0e15990119fc5aafe7c2.svg";
export { ForwardRef as ReactComponent };